export default "__VITE_ASSET__lbdRLbbU__"